import React from 'react';
import { DE_DE, FR_FR } from 'utils/constants/LanguageRegionCode';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './styles/styles.module.scss';
import OnePercentModule from './OnePercentModule';
import oneTreeSrc from './one-tree.svg';
import onePercentSrc from './one-percent.svg';
import noTraceSrc from './no-trace.svg';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import useUser from 'hooks/useUser';
import { FormattedMessage } from 'react-intl';
import { logProPurchaseGiveBackButtonClicked } from '@alltrails/analytics/amplitudeFunctions';

const OnePercentBlock = () => {
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <div className={styles.modulesContainer}>
          <OnePercentModule
            iconSrc={onePercentSrc}
            title={<FormattedMessage defaultMessage="1% for the Planet" />}
            text={<FormattedMessage defaultMessage="A portion of every Pro membership goes to protecting the wild places we cherish." />}
          />
          <OnePercentModule
            iconSrc={oneTreeSrc}
            title={<FormattedMessage defaultMessage="10,000 trees (and counting)" />}
            text={<FormattedMessage defaultMessage="From our birthday to employee anniversaries, we celebrate by giving to One Tree Planted." />}
          />
          <OnePercentModule
            iconSrc={noTraceSrc}
            title={<FormattedMessage defaultMessage="No trace on the trail" />}
            text={<FormattedMessage defaultMessage="As a Leave No Trace partner, we’re committed to keeping outdoor spaces clean, safe, and kind." />}
          />
        </div>
        <a
          href={checkLinkAndAppendLanguage(user?.pro ? '/gift?ref=homepage_gift_onepercentblock' : '/pro?ref=homepage_pro_onepercentblock')}
          data-testid="get-pro-and-give-back"
          className={`${styles.ctaLink} ${[DE_DE, FR_FR].includes(languageRegionCode) ? styles.smallCtaText : ''}`}
          onClick={() => logProPurchaseGiveBackButtonClicked()}
        >
          {user?.pro ? <FormattedMessage defaultMessage="Give Pro and give back" /> : <FormattedMessage defaultMessage="Get Pro and give back" />}
        </a>
      </div>
    </div>
  );
};

export default OnePercentBlock;
